import { useSelector } from 'react-redux'
import { selectAllModals } from 'data/Modals/selectors'
import { ModalInstance } from './ModalInstance'

/**
 * Renders all active modals in the app.
 * Each modal is driven by Redux state.
 * MuiModal handles stacking, focus, and transitions automatically.
 */
export const ModalsRoot = () => {
  const modals = useSelector(selectAllModals)

  return (
    <>
      {Object.values(modals).map((modal) => (
        <ModalInstance key={modal.identifier} modal={modal} />
      ))}
    </>
  )
}
